/** Display labels for stored role values (DB keeps "employee"). */
export function formatRoleLabel(role: string | null | undefined): string {
  const r = normalizeRole(role);
  if (r === "employee") return "Staff";
  if (r === "end-user") return "End User";
  if (!r) return "";
  return r.charAt(0).toUpperCase() + r.slice(1);
}

export function normalizeRole(role: string | null | undefined): string {
  return String(role || "")
    .trim()
    .toLowerCase()
    .replace(/_/g, "-");
}

export function isAdminRole(role: string | null | undefined): boolean {
  return normalizeRole(role) === "admin";
}

/** Staff (employee) and dealer have restricted panel access (not full admin). */
export function isLimitedPanelRole(role: string | null | undefined): boolean {
  const r = normalizeRole(role);
  return r === "employee" || r === "dealer";
}

/** Dealer: orders, invoices, estimates (scoped like orders). */
export const DEALER_PANEL_PATHS = ["/panel/orders", "/panel/invoices", "/panel/estimates"] as const;

/** Staff: orders, invoices, estimates. */
export const STAFF_PANEL_PATHS = [
  "/panel/orders",
  "/panel/invoices",
  "/panel/estimates",
] as const;

/** @deprecated use role-specific lists */
export const LIMITED_PANEL_PATHS = DEALER_PANEL_PATHS;

export function canAccessPanelPath(
  role: string | null | undefined,
  pathname: string
): boolean {
  if (isAdminRole(role)) return true;
  const path = String(pathname || "").replace(/\/+$/, "") || "/";
  const r = normalizeRole(role);
  const allowed =
    r === "employee"
      ? STAFF_PANEL_PATHS
      : DEALER_PANEL_PATHS;
  return allowed.some(
    (p) => path === p || path.startsWith(`${p}/`)
  );
}

export function canAccessEstimates(role: string | null | undefined): boolean {
  const r = normalizeRole(role);
  return r === "admin" || r === "employee" || r === "dealer";
}
